import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthProvider";
import { useNavigate } from "react-router-dom";

const ForgetPassword = () => {
  const [form, setForm] = useState("");
  const [error, setError] = useState({});
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data={
      ...form, 
      otpType:"password"
    }
    try {
    } catch (error) {
      console.error("Login failed", error);
      setError(
        error?.message || "Unable to reset your password now. Please try later"
      );
    }
  };

  return (
    <div className="w-100 min-h-[75vh] mb-6 grid items-center">
      <form
        onSubmit={handleSubmit}
        className="w-full md:w-3/4 lg:w-2/4 max-w-lg mx-auto rounded-lg px-4 sm:px-10 pt-8  text-center"
      >
        <h2 className="mb-8 text-gray-800 text-4xl">Reset Password</h2>
        <h5>Enter your email below to reset your password</h5>
        {error ? (
          <h6 className="Login-error text-red-900 block">{error?.message}</h6>
        ) : null}
        <input
          type="email"
          name="email"
          placeholder="Email"
          onChange={handleChange}
          required
          className="p-3 px-6 m-2 mb-0 block mx-auto bg-gray-200 rounded-md placeholder-grey-500 w-full outline-none focus:bg-white border-2 border-gray-200"
        />
        <button
          className="bg-gray-900 w-full py-2 mt-4 rounded-lg text-white hover:bg-gray-800"
          type="submit"
        >
         Send OTP
        </button>
      </form>
    </div>
  );
};

export default ForgetPassword;
